import dynamic from 'next/dynamic';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import seoconfig from '@/seoconfig/ocean-ev-charger';
import SEOlinksA from '@/components/SEOlinksA';
import OceanEvCharger from '@elem/compPage/OceanEvCharger';
import { redirectTo404 } from '@/utils';

const whiteLocaleList = seoconfig.include;

export default function Oceanevcharger({ SEO }: any) {
    const { useRouter, useEffect, useLang } = useGlobal();
    const { t } = useLang('oceanevcharger');
    const router = useRouter();
    const { locale } = router;
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });

    return (
        <PageLayout isNoFixed hideToTop theme="black">
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={String(locale)} list={seoconfig.include} pathname={seoconfig.url} />
            <GtmPageLoad />
            <OceanEvCharger />
        </PageLayout>
    );
}

export async function getServerSideProps({ locale }: { locale: string }) {
    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
